<template>
    <b-row v-if="!jwt" align-v="center" class="login-app" style="min-height: 100vh">
        <b-col style="max-width: 440px; margin: auto">
            <slot name="header"/>
            <b-alert
                    id="login-alert"
                    v-model="alert.show"
                    :variant="alert.variant || 'info'"
                    dismissible
            >{{alert.message}}</b-alert>
            <div class="col text-center mt-3">
                <img src="/konametrix.png" width="195px"/>
            </div>
            <h1 style="margin-bottom: 35px; color:#fff; font-weight: bold; text-align:center; margin-top:15px">
                Customer Portal
            </h1>
            <b-form @submit.prevent="submit" style="font-size: 22px; font-weight: bold">
                <b-form-group
                        label="EMAIL ADDRESS"
                >
                    <b-form-input
                            id="login-email"
                            v-model="form.email"
                            type="email"
                            required
                            placeholder="Enter email"
                    />
                </b-form-group>
                <b-form-group
                        label="PASSWORD"
                        style="margin-top:25px"
                >
                    <b-form-input
                            id="login-pwd"
                            v-model="form.password"
                            type="password"
                            required
                            placeholder="Enter your password"
                    ></b-form-input>
                </b-form-group>
                <div class="col text-center mt-4">
                    <b-button
                            id="login-button"
                            type="submit"
                            variant="dark"
                            style="margin-top:20px"
                    >SUBMIT</b-button>
                </div>
                <div>
                    <div class="d-flex align-items-center justify-content-center" style="font-weight: bold; font-size: 18px">&nbsp;</div>
                    <span class="d-flex align-items-center justify-content-center" style="font-weight: bold; font-size: 18px">
                            <b-link style="color:white; text-align:center; margin:auto" @click="self_install()">
                                    Install Device
                            </b-link>
                    </span>
                </div>
                <slot name="footer"/>
            </b-form>
        </b-col>
    </b-row>

</template>

<script>

    import axios from 'axios'

    export default {

        name: 'App',
        data() {
            return {
                form:{
                    email:'', 
                    password:''
                },
                jwt: null,
                alert:{show:false, message:'', variant:''}
            }
        },
        created() {
            this.jwt = this.$route.query.jwt
            if (this.jwt != null) {
                this.login_with_jwt()
            }
        },
        methods: {
            async login_with_jwt() {

                const { data } = await axios.get(
                    process.env.VUE_APP_API_AUTH_URL + "auth/relogin",
                    { headers: {'Access-Control-Allow-Origin': '*', 'Authorization': 'Bearer ' + this.jwt}}
                )
                this.handle_login_response(data)
            },
            async submit(){
                try{
                    this.alert = {show: true, message: "Waiting for Response..."}
                    const { data } = await axios.post(
                        process.env.VUE_APP_API_AUTH_URL + "auth/login", 
                        this.form,
                        { headers: {'Access-Control-Allow-Origin': '*'}}
                    )
                    this.alert = {show: true, message: "Success!", variant: 'success'}
                    this.handle_login_response(data)
                } catch(e){
                    e.response && e.response.data && e.response.data.message
                    ? this.alert = {show: true, message: e.response.data.message, variant: 'danger'}
                    : this.alert = {show: true, message: "Authentication failed", variant: 'danger'}
                }
            },
            async handle_login_response(data) {
                setTimeout(() => {
                    if (data.data.user.roleCode === 'CA' || data.data.user.roleCode === 'CU' ) {
                        localStorage.setItem('user', JSON.stringify(data.data.user))
                        localStorage.setItem('jwt', data.data.token)
                        localStorage.setItem('authenticated', true)

                        const jwt_data = this.h_get_jwt_data(data.data.token);
                        localStorage.setItem('expiration_token_time', jwt_data.exp);

                        this.$emit('setAuthenticated', true, data.data.user)
                        const activeUser = data.data.user.accountStatus !== 'P';
                        this.$emit('activate_user', activeUser)
                        localStorage.setItem('active_user', activeUser)
                    } else {
                        this.alert = {show: true, message: "invalid role", variant: 'danger'}
                        this.jwt=null
                    }
                }, 500)
            },
            self_install() {
                localStorage.setItem('authenticated', true)
                localStorage.setItem('self_install_user', true)
                this.$emit('self_install', true)
                this.$emit('setAuthenticated', true, {"email":"","userId":0,"accountId":0,"roleCode":"SIU","firstName":"Self Install","lastName":"User","accountStatus":"P"})
                this.$emit('activate_user', true)
                localStorage.setItem('active_user', true)
                this.$router.push('/selfinstall')
                localStorage.setItem('user', 
                    JSON.stringify({"email":"","userId":0,"accountId":0,"roleCode":"SIU","firstName":"Self Install","lastName":"User","accountStatus":"P"}))
            },
            auth_navigation(){
                this.$emit('auth_navigation', true)
            }
        }
    }
    
</script>

<style scoped>

    .login-app {
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #fff;

        background: linear-gradient(to top, transparent, #333),
        url("/background.png");
    }



</style>
